import React from 'react';
import useAutomationTextFormatter from '../../../AutomationStudio/hooks/useAutomationTextFormatter';

/**
 * Renders Automation Studio text with stored-form tokens resolved to display form.
 * Handles `${_id:<uuid>}` variables and `@[<fileId>]` file refs (same as legacy Studio).
 */
export default function AutomationText({
    text,
    as: Tag = 'span',
    fallback = null,
    ...rest
}) {
    const { format } = useAutomationTextFormatter();

    if (text == null || text === '') return fallback;

    const rendered = format(text);
    if (rendered == null || rendered === '') return fallback;

    return <Tag {...rest}>{rendered}</Tag>;
}
